<template>
  <section>
    <div class="table-container">
      <!-- 搜索栏（固定） -->
      <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
        <!-- 电脑端使用 Element UI 搜索框 -->
        <div v-if="isDesktop" class="desktop-search-wrapper">
          <div class="search-row">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索产品名"
              prefix-icon="el-icon-search"
              class="search-input"
              @keyup.enter="handleSearch"
            >
              <template slot="append">
                <el-button @click="handleSearch">搜索</el-button>
              </template>
            </el-input>

            <div class="button-group">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd" class="add-button">
                添加
              </el-button>
              <el-button type="primary" size="small" icon="el-icon-filter" @click="toggleFilter" class="filter-button">
                {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
              </el-button>
            </div>
          </div>

          <!-- 电脑端筛选面板 -->
          <div v-if="isFilterOpen" class="filter-panel">
            <div class="filter-row">
              <!-- 产品类别筛选 -->
              <div class="filter-item">
                <label>产品类别：</label>
                <el-select v-model="params.category" placeholder="选择类别" style="width: 150px;">
                  <el-option value="" label="全部" />
                  <el-option v-for="category in categoryList" :key="category.id" :label="category.name" :value="category.id" />
                </el-select>
              </div>
              
              <!-- 语言筛选 -->
              <div class="filter-item">
                <label>语言：</label>
                <el-select v-model="params.language_code" placeholder="选择语言" style="width: 150px;">
                  <el-option value="" label="全部" />
                  <el-option v-for="lang in languageList" :key="lang.code" :label="lang.name" :value="lang.code" />
                </el-select>
              </div>
            </div>
            <div class="filter-actions">
              <div class="applied-filters">
                <span v-if="!params.category" class="filter-tag filter-tag-empty">
                  当前无筛选条件
                </span>
              </div>
              <div class="filter-buttons">
                <el-button size="small" @click="resetFilter">重置筛选</el-button>
                <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端使用 Vant 搜索框 -->
        <div v-else class="mobile-search-wrapper">

          <!-- 手机端添加按钮 -->
          <div class="mobile-add-button">
            <van-button type="primary" size="small" block icon="plus" @click="handleOpenAdd" style="margin-top: 10px;">
              添加
            </van-button>
          </div>

          <!-- 手机端筛选面板 -->
          <div v-if="isFilterOpen" class="mobile-filter-panel">
            <!-- 手机端已应用筛选条件显示 -->
            <div class="mobile-applied-filters">
              <div v-if="!appliedFilterForm.category" class="applied-tags">
                <span class="mobile-filter-tag empty">
                  当前无筛选条件
                </span>
              </div>
            </div>

            <div class="mobile-filter-actions">
              <van-button type="default" size="small" @click="resetFilter">重置</van-button>
              <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
            </div>
          </div>

          <!-- 手机端筛选展开按钮 -->
          <div class="mobile-filter-toggle" @click="toggleFilter">
            <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" />
            <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
          </div>
        </div>
      </div>

      <!-- 内容区域（可滚动） -->
      <div class="content-container">
        <!-- 电脑端表格 -->
        <div class="table-wrapper" v-if="isDesktop">
          <el-table :data="productList" style="width: 100%" tooltip-effect="dark" empty-text="暂无数据"
            class="desktop-table" :height="tableHeight">
            <el-table-column label="产品图片" align="center" width="100px" fixed>
              <template slot-scope="scope">
                <div
                  v-if="scope.row.image"
                  style="width: 80px; height: 80px; cursor: pointer;"
                  @click="handleImagePreview(scope.row.image)"
                >
                  <img
                    :src="scope.row.image"
                    style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px;"
                    @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex';"
                  />
                  <div style="width: 80px; height: 80px; background-color: #f5f7fa; display: none; align-items: center; justify-content: center; color: #909399; border-radius: 4px;">
                    <i class="el-icon-picture-outline" style="font-size: 24px;"></i>
                  </div>
                </div>
                <div v-else style="width: 80px; height: 80px; background-color: #f5f7fa; display: flex; align-items: center; justify-content: center; color: #909399; border-radius: 4px;">
                  <i class="el-icon-picture-outline" style="font-size: 24px;"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="产品名" prop="name" align="left" width="300px" fixed>
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
                <el-tag v-if="scope.row.tag" size="mini" type="danger" style="margin-left: 6px;">{{ scope.row.tag }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="语言" prop="language_name" align="left">
              <template slot-scope="scope">
                {{ scope.row.language_name }}({{ scope.row.language_code }})
              </template>
            </el-table-column>
            <el-table-column label="品类名" prop="category_name" align="left">
            </el-table-column>
            <el-table-column label="副标题" prop="sub_title" align="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="首页展示" align="center" width="100px">
              <template slot-scope="scope">
                <el-switch
                  :value="scope.row.is_home === 1"
                  active-color="#13ce66"
                  @change="handleHomeSwitch(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="上传时间" prop="created_at" align="left" width="200px">
            </el-table-column>
            <el-table-column label="排序" prop="sort" align="center" width="80px" />
            <el-table-column label="操作" align="right" fixed="right" width="155px">
              <template slot-scope="scope">
                <div class="table-actions">
                  <el-link @click="handleEdit(scope.row)">
                    <i class="el-icon-edit" style="font-size:16px;"></i>编辑
                  </el-link>
                  <el-dropdown @command="command($event, scope.row)">
                    <span class="el-dropdown-link">
                      更多操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="view">查看</el-dropdown-item>
                      <el-dropdown-item command="remove" >删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 -->
      <div v-if="isDesktop && total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :page-size.sync="params.page_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 查看链接 -->
    <el-drawer
      :visible.sync="showContentVisible"
      :with-header="false"
      :show-close="true"
      size="70%"
    >
      <iframe
        :src="showContent.link"
        style="width: 100%; height: 100%; border: none;"
      ></iframe>
    </el-drawer>
    <!-- 图片预览对话框 -->
    <el-dialog :visible.sync="imageDialogVisible" append-to-body width="80%">
      <img width="100%" :src="previewImage" alt/>
    </el-dialog>
    <!-- 添加/编辑对话框 -->
    <template v-if="isDesktop">
      <el-drawer
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        size="70%"
        :before-close="handleClose"
      >
        <add-product
          :product="editingItem"
          @save="handleSave"
          @cancel="handleClosePopup"
        />
      </el-drawer>
    </template>
    <template v-else>
      <van-popup
        v-model="dialogVisible"
        position="bottom"
        :round="true"
        :style="{ height: '80%' }"
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <h3>{{ dialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <add-product
            :product="editingItem"
            @save="handleSave"
            @cancel="handleClosePopup"
          />
        </div>
      </van-popup>
    </template>
  </div>
</section>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import AddProduct from './components/add-product.vue'
import { getProducts, updateProduct,deleteProduct } from '@/api/website'
import { Dialog } from 'vant'
export default {
  name: 'ProductPage',
  components: {
    AddProduct
  },
  data() {
    return {
      isDesktop: true,
      showContentVisible: false,
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      direction: "rtl",
      height: 0,
      filterForm: {
        category: '',
        language: ''
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        category: '',
        language: ''
      },
      // 分类和语言列表
      categoryList: [
        { id: 1, name: '品类1' },
        { id: 2, name: '品类2' },
        { id: 3, name: '品类3' },
        { id: 4, name: '品类4' }
      ],
      languageList: [
        { code: 'zh', name: '中文' },
        { code: 'en', name: 'English' },
        { code: 'ko', name: '한국어' }
      ],
      // 手机端操作菜单
      showActionSheet: false,
      currentRow: null,
      actionSheetActions: [
      ],

      dialogVisible: false,
      dialogTitle: '',
      editingItem: null,
      productList: [
        // 示例数据
        {
          id: 1,
          name: '产品1',
          language_code: 'zh',
          language_name: '中文',
          category_id: 1,
          category_name: '品类1',
          image: 'https://via.placeholder.com/200',
          created_at: '2026-03-20 10:00:00'
        },
        {
          id: 2,
          name: 'Product 2',
          language_code: 'en',
          language_name: 'English',
          category_id: 2,
          category_name: 'Category 2',
          image: 'https://via.placeholder.com/200',
          created_at: '2026-03-19 14:30:00'
        }
      ],
      showContent:{},
      params: {
        page: 1,
        page_count: 10,
        category: '',
        language_code: ''
      },
      total: 0,
      // 图片预览
      imageDialogVisible: false,
      previewImage: ''
    }
  },
  computed: {
    // 动态计算表格高度
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 200 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 120 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    // 初始化时，将当前筛选条件设为已应用条件
    this.appliedFilterForm = JSON.parse(JSON.stringify(this.params))
    this.getTableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    getTableData() {
      // 实际项目中应该调用API获取数据
      getProducts(this.params).then(res => {
        this.productList = res.data.data || []
        this.total = res.data.total
      })
    },
    handleSizeChange(val) {
      this.params.page_count = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getTableData()
    },
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
      this.getTableData()
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.params.page = 1
      this.getTableData()
    },
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        page: 1,
        page_count: 10,
        category: '',
        language_code: ''
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.params = JSON.parse(JSON.stringify(initialFilter))
      this.params.page = 1
      this.getTableData()
    },
    handleAdd() {
      this.dialogTitle = '添加产品'
      this.editingItem = null
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.dialogTitle = '编辑产品'
      this.editingItem = { ...item }
      this.dialogVisible = true
    },
    // 处理命令
    command(cmd, row) {
      if(cmd === 'view'){
        this.showContent = row
        this.showContentVisible = true
      }
      if (cmd === 'remove') {
        this.handleDelete(row.id)
      }
    },
    
    handleDelete(id) {
      this.$confirm('确定要删除吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteProduct(id).then(res => {
          if (res.code === 200) {
            this.getTableData()
            this.$message.success('删除成功')
          }
        })
      }).catch(() => {})
    },
    // 显示手机端更多操作菜单
    showMoreActions(row) {
      this.currentRow = row
      this.showActionSheet = true
    },
    // 处理手机端操作菜单选择
    onActionSheetSelect(action, index) {
      if (action.name === '删除') {
        this.handleDelete(this.currentRow.id)
      }
      this.showActionSheet = false
    },
    // 关闭手机端操作菜单
    onActionSheetClose() {
      this.currentRow = null
    },
    handleSave(data) {
      // 处理保存逻辑
      this.getTableData()
      this.$message.success('保存成功')
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.dialogVisible = false
      }).catch(function() {})
    },
    handleHomeSwitch(row) {
      var newVal = row.is_home === 1 ? 0 : 1
      updateProduct(row.id, { is_home: newVal }).then(res => {
        if (res.code === 200) {
          row.is_home = newVal
          this.$message.success(newVal === 1 ? '已设为首页展示' : '已取消首页展示')
        }
      })
    },
    handleImagePreview(image) {
      this.previewImage = image
      this.imageDialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-search-container {
  margin-bottom: 15px;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域 */
.content-container {
  flex: 1;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

/* 电脑端表格 */
.table-wrapper {
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions {
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-title {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.card-title h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* Vant下拉菜单样式优化 */
.card-actions .van-dropdown-menu {
  font-size: 13px;
  flex-shrink: 0;
}

/* 手机端空状态 */
.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }

  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }

  .card-actions .van-dropdown-menu {
    width: 100%;
  }
}

/* 手机端弹窗样式 */
.popup-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--background);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.popup-header .close-icon {
  font-size: 20px;
  color: var(--text-200);
  cursor: pointer;
  transition: color 0.2s ease;
}

.popup-header .close-icon:hover {
  color: var(--text);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--background);
}

/* 筛选面板样式 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }

  .search-container .search-input {
    display: none;
  }

  .content-container {
    padding: 10px 0;
  }

  .search-input {
    max-width: 100%;
  }

  .pagination-container {
    text-align: center;
    padding: 15px;
  }

  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .filter-item {
    width: 100%;
  }

  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {

  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }

  .desktop-table {
    display: block;
  }

  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container {
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }

  .van-search {
    padding: 0;
  }

  .desktop-table {
    display: none;
  }

  .mobile-cards {
    display: flex;
  }

  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-input {
    max-width: 100%;
  }
}
</style>